// extracted by mini-css-extract-plugin
export var bottomRightDock = "_4h-0";